import { baseSpacingUnit } from '@gto/ui/theme/design-tokens'

import { IconCardClub } from '@/assets/icons'
import { zIndex } from '@/utils/constants'

export type AbsoluteSuitsOnCornersProps = {
  top?: number
  translateY?: string
}

// please be aware to add position: relative to the parent component
export const AbsoluteSuitsOnCorners = ({
  top,
  translateY = '50%',
}: AbsoluteSuitsOnCornersProps) => {
  return (
    <div
      className="absolute inset-x-0 flex items-center justify-between gap-2 text-primary-main"
      style={{
        top: `${(top ?? 4) * baseSpacingUnit}px`,
        zIndex: zIndex.suitsOnCorners,
        transform: `translateY(${translateY})`,
      }}
    >
      <IconCardClub
        color="inherit"
        height={9}
        width={9}
      />
      <IconCardClub
        color="inherit"
        height={9}
        width={9}
      />
    </div>
  )
}
